import React from "react";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import { renderResults, renderFacets } from "./renderViews";


import './i18n/config';
import { useTranslation } from 'react-i18next'
import {
    ErrorBoundary,
    Facet,
    SearchProvider,
    SearchBox,
    PagingInfo,
    Paging,
    Sorting,
    WithSearch
} from "@elastic/react-search-ui";

import { Layout } from "@elastic/react-search-ui-views";
import {
    buildAutocompleteQueryConfig,
    buildFacetConfigFromConfig,
    buildSearchOptionsFromConfig,
    buildSortOptionsFromConfig,
    getConfig,
    getFacetFields,
    showSort
} from "./config/config-helper";

const { hostIdentifier, searchKey, endpointBase, engineName } = getConfig();
const connector = new AppSearchAPIConnector({
    searchKey,
    engineName,
    hostIdentifier,
    endpointBase
});

function App() {
    const { t } = useTranslation();
    const config = {
        searchQuery: {
            facets: buildFacetConfigFromConfig(t),
            ...buildSearchOptionsFromConfig(t)
        },
        autocompleteQuery: buildAutocompleteQueryConfig(t),
        apiConnector: connector,
        alwaysSearchOnInitialLoad: true
    };
    return (

        <SearchProvider
            config={config}>
            <WithSearch mapContextToProps={({ wasSearched, results }) => ({ wasSearched, results })}>
                {({ wasSearched, results }) => {
                    return (
                        <div className="App">
                            <ErrorBoundary>
                                <Layout
                                    header={<SearchBox autocompleteSuggestions={true} inputView={({ getAutocomplete, getInputProps, getButtonProps }) => (
                                        <>
                                            <div className="sui-search-box__wrapper">
                                                <input
                                                    {...getInputProps({
                                                        placeholder: t("search_bar_place_holder")
                                                    })}
                                                />
                                                {getAutocomplete()}
                                            </div>
                                            <input
                                                {...getButtonProps({
                                                    value: t("search_button_text")
                                                })}
                                            />
                                        </>
                                    )} />}
                                    sideContent={
                                        <div>
                                            {wasSearched && showSort() && (
                                                <Sorting
                                                    label={t("Sort by")}
                                                    sortOptions={buildSortOptionsFromConfig(t)}
                                                />
                                            )}
                                            {getFacetFields().map(facetField => (
                                                <Facet
                                                    key={facetField}
                                                    view={({ className,
                                                        label,
                                                        onMoreClick,
                                                        onRemove,
                                                        onSelect,
                                                        options,
                                                        showMore,
                                                        showSearch,
                                                        onSearch,
                                                        searchPlaceholder }) => (
                                                        renderFacets(className,
                                                            label,
                                                            onMoreClick,
                                                            onRemove,
                                                            onSelect,
                                                            options,
                                                            showMore,
                                                            showSearch,
                                                            onSearch,
                                                            searchPlaceholder, t)
                                                    )}
                                                    field={facetField}
                                                    label={facetField}
                                                    show={10}
                                                />
                                            ))}
                                        </div>
                                    }
                                    bodyContent={
                                        results.map(r => (
                                            renderResults(r, t)
                                        ))
                                    }
                                    bodyHeader={
                                        <React.Fragment>
                                            {wasSearched &&
                                                <PagingInfo
                                                    view={({ start, end, searchTerm, totalResults }) => (
                                                        <div className="sui-paging-info">
                                                            {t("search_paging_showing")}{" "}
                                                            <strong>
                                                                {start} - {end}
                                                            </strong>{" "}
                                                            {t("search_paging_out_of")} <strong>{totalResults}</strong>
                                                            {searchTerm && (
                                                                <>
                                                                    {" "}
                                                                    {t("search_paging_for")}: <em>{searchTerm}</em>
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            }
                                        </React.Fragment>
                                    }
                                    bodyFooter={<Paging />}
                                />
                            </ErrorBoundary>
                        </div>
                    );
                }}
            </WithSearch>
        </SearchProvider>
    );
}

export default App;
